import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printqrtruck',
  templateUrl: './printqrtruck.component.html',
  styleUrls: ['./printqrtruck.component.css']
})
export class PrintqrtruckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
